export default function ApplicationLogo(props) {

    const { company } = props;
    const logo = company?.logo ? company.logo : '/images/logo-CND-VI.png';
    const logoAlt = company?.name ? company.name : 'CND-VI';

    return (
        <img src={logo} height={70} alt={logoAlt} />
    );
}
